/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { BrowserRouter } from "react-router-dom";
import awsConfig from "./awsConfig";
import Amplify from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import { AuthProps } from "aws-amplify-react/props";
import { ApolloProvider } from "@apollo/react-hooks";
import { Container } from "semantic-ui-react";
import LoadIndicator from "./components/LoadIndicator";
import { LandingPageWrapper } from "./components/Authenticator";
import { Home } from "./components/Home";
import { apolloClient } from "./services/backend";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Logout from "./components/Home/Logout";
import styles from "./App.module.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

Amplify.configure(awsConfig);

const authenticatorComponents = [
  <LandingPageWrapper key="LandingPageWrapper" />,
  <LoadIndicator override={"Loading"} key="LoadIndicator" />,
];

const stripePromise = process.env.REACT_APP_STRIPE_REPUBLISHABLE_KEY
  ? loadStripe(process.env.REACT_APP_STRIPE_REPUBLISHABLE_KEY)
  : null;

const App: React.FC<AuthProps> = (props) => {
  try {
    if (!props.authData.signInUserSession.idToken.payload.email_verified) {
      return <Logout />;
    }
  } catch {
    return <Logout />;
  }

  return (
    <ApolloProvider client={apolloClient}>
      <Elements
        stripe={stripePromise}
        options={{
          fonts: [
            {
              cssSrc: "https://fonts.googleapis.com/css?family=Open+Sans:400",
            },
          ],
        }}
      >
        <Container fluid id={styles.appContainer}>
          <BrowserRouter>
            <div className={styles.menuPlaceholder}></div>
            <Menu
              userId={
                props.authData.signInUserSession.idToken.payload["custom:uid"]
              }
            />
            <Home {...props} />
          </BrowserRouter>
        </Container>
        <Footer />
      </Elements>
    </ApolloProvider>
  );
};

export default withAuthenticator(App, false, authenticatorComponents);
